/**
 * Story carousel — WHOOP-style split section: timed slides + vertical progress bar.
 */
(function () {
  "use strict";

  var MOBILE_MQ = "(max-width: 1023px)";

  function isMobile() {
    return window.matchMedia(MOBILE_MQ).matches;
  }

  function restartProgressFill(slideEl) {
    var fill = slideEl && slideEl.querySelector("[js-story-track-fill]");
    if (!fill) return;
    fill.style.animation = "none";
    void fill.offsetHeight;
    fill.style.animation = "";
  }

  function initCarousel(root) {
    if (!root || root.dataset.storyCarouselInit === "true") return;
    root.dataset.storyCarouselInit = "true";

    var slides = root.querySelectorAll("[js-story-slide]");
    var panels = root.querySelectorAll("[js-story-panel]");
    if (!slides.length || slides.length !== panels.length) return;

    var durationMs = parseInt(root.dataset.autoplayMs, 10);
    if (isNaN(durationMs) || durationMs < 1000) durationMs = 7000;

    var current = 0;
    var timerId = null;
    var paused = false;

    function prefersReducedMotion() {
      return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    }

    function goTo(index) {
      if (index < 0 || index >= slides.length) return;
      current = index;

      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle("is-active", active);
        slide.setAttribute("aria-selected", active ? "true" : "false");
        if (active) restartProgressFill(slide);
      });

      panels.forEach(function (panel, i) {
        var active = i === index;
        panel.classList.toggle("is-active", active);
        if (active) {
          panel.removeAttribute("hidden");
        } else {
          panel.setAttribute("hidden", "");
        }
      });
    }

    function next() {
      goTo((current + 1) % slides.length);
    }

    function stopAutoplay() {
      if (timerId !== null) {
        window.clearInterval(timerId);
        timerId = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (paused || slides.length < 2 || prefersReducedMotion()) return;
      timerId = window.setInterval(next, durationMs);
    }

    slides.forEach(function (slide, i) {
      slide.addEventListener("click", function () {
        goTo(i);
        startAutoplay();
      });

      slide.addEventListener("focus", function () {
        if (isMobile()) return;
        goTo(i);
        startAutoplay();
      });

      slide.addEventListener("mouseenter", function () {
        if (isMobile()) return;
        paused = true;
        goTo(i);
        stopAutoplay();
      });

      slide.addEventListener("mouseleave", function () {
        if (isMobile()) return;
        paused = false;
        goTo(i);
        startAutoplay();
      });
    });

    root.addEventListener("pointerenter", function () {
      if (isMobile()) return;
      paused = true;
      stopAutoplay();
    });

    root.addEventListener("pointerleave", function () {
      if (isMobile()) return;
      paused = false;
      goTo(current);
      startAutoplay();
    });

    window.addEventListener("resize", function () {
      if (isMobile()) {
        paused = false;
        startAutoplay();
      }
    });

    document.addEventListener("visibilitychange", function () {
      if (document.hidden) {
        stopAutoplay();
      } else if (!paused) {
        startAutoplay();
      }
    });

    goTo(0);
    startAutoplay();
  }

  function initAll(scope) {
    var rootScope = scope && scope.querySelector ? scope : document;
    rootScope.querySelectorAll("[js-story-carousel]").forEach(initCarousel);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
